<script lang="ts">
import { push } from 'svelte-spa-router'
import { fade, slide } from 'svelte/transition'
import { toast } from '@zerodevx/svelte-toast'
import Icon from '@iconify/svelte'

import { _ } from '../i18n.svelte'
import { copyClipbord, isNotTextEmpty } from '../util.svelte'
import MessageCard from '../components/messageCard.svelte'
import CopyInput   from '../components/copyInput.svelte'

import HmacMD5 from 'crypto-js/hmac-md5'

const DEFAULT_MESSAGE = _('default_message', '')
const SECRET_WORD = '***'

export let text = ''
export let key = ''


const hashTag = _('hash_tag', '#D8S5')

$:hash            = HmacMD5(text.trim(), key===''?'secret':key).toString();
$:secretedMessage = (text || DEFAULT_MESSAGE).replace(/(?<=\[).+?(?=\])/g, SECRET_WORD);
$:tweetText       = secretedMessage + '\n#' + hash + '\n' + hashTag

$: numOfSecret   = (secretedMessage.match(/\[\*\*\*\]/g) || []).length;
$: isShowInstructions = !isNotTextEmpty(text)
</script>
<template lang="pug">
main
    section.section-input(transition:slide)
        .container.container-input
            .generate-input__form__area
                .generate-input__section-title__text
                    | {_('step1', 'STEP 1: Enter the message you wish to declare.')}
                textarea.generate-input__form-message__textarea.__placeholder-font-color__gray(
                    rows="5"
                    bind:value="{text}"
                    placeholder="{DEFAULT_MESSAGE}"
                )
            .generate-input__secret-sample__area
                .generate-input__section-sub-title__text.__margin-top__3pct
                    +if('text && text.length > 0')
                        | {_('become_secret', 'A message that became secret.')}
                        +else()
                        | {_('become_secret_example', 'Example of confidential message.')}
                MessageCard(message="{secretedMessage}" hash="{hash}" hashTag="{hashTag}" isShowInstructions="{isShowInstructions}")
                +if('isNotTextEmpty(text) && numOfSecret === 0')
                    p(transition:slide)
                        | {_('TODO', '秘密にする部分を [ ] で囲んでください。')}

    +if('isNotTextEmpty(text) && numOfSecret > 0')
        section.section-password(transition:slide)
            .container.container-password
                .generate-password__form__area
                    .generate-password__section-title__text
                        | {_('step2', 'STEP 2: Enter your secret password.')}
                    input.generate-password__form-secret__input.__placeholder-font-color__gray(
                        bind:value="{key}"
                        placeholder="(DEFAULT: secret)"
                    )
                
                .generate-password__notion__wrapper
                    small
                        | {_('TODO', '※ 宣言内容から推測しにくい文字列を推奨しています。')}
                        br
                        | {_('TODO', '※ 宣言内容を公開する際に合言葉も公開するため、他のサービスで使用しているパスワード等は使わないでください。')}

    +if('isNotTextEmpty(text) && numOfSecret > 0')
        section.section-share(transition:slide)
            .container.container-share
                div
                    .generate-share__section-title__text.__margin-top__3pct {_('step3', 'STEP 3: Share your results!')}
                    .main__share-button__area
                        a.main__share-button__wrapper.--twitter.__hover-opacity__0-5(href="https://twitter.com/intent/tweet?url={encodeURIComponent('https://secret.koneta.click/#/resolve/')}&text={encodeURIComponent(tweetText)}" target="_blank" rel="nofollow noopener noreferrer")
                            Icon(icon="mdi:twitter")
                            | Twitter
                        CopyInput(text="{`${secretedMessage}\n#${hash}`}")

                .generate-share__urls__wrapper
                    .generate-share__description__text
                        | 秘密部分を確認してもらったり、内容を発表する場合はこちらのURLを使ってください。
                    .generate-share__header__text
                        | 確認用のURL
                    CopyInput(text="https://secret.koneta.click/#/resolve/{encodeURIComponent(tweetText)}/" isShowCopyInput="{true}" isShowCopyButotnText="{false}")
                    .generate-share__header__text
                        | 発表用のURL
                    CopyInput(text="https://secret.koneta.click/#/answer/{encodeURIComponent(hash)}/{encodeURIComponent(text)}/{encodeURIComponent(key===''?'secret':key)}" isShowCopyInput="{true}" isShowCopyButotnText="{false}")
                    .generate-share__notion__wrapper
                        small
                            | ※ 発表用URLを公開すると秘密の内容が分かってしまうのでご注意ください。
                            br
                            | ※ 秘密部分が分からなくならないよう、必ず発表用URLをメモしておいてください。
</template>
<style lang="scss">
.section-input {
    .container-input {
        .generate-input__section-title__text {
            font-size: 1.1rem;
            font-weight: bold;
        }
        .generate-input__section-sub-title__text {
            font-size: 1rem;
            font-weight: bold;
        }
        
        .generate-input__form__area {
            text-align: left;
            .generate-input__form-message__textarea {
                width: 100%;
                padding: 2%;
                font-size: 1rem;
                border: 1px solid #bebebe;
                border-radius: 10px;
            }
        }

        .generate-input__secret-sample__area {
            width: 70%;
            margin: 0 auto;
            @media screen and (max-width: 600px) {
                width: 100%;
            }
        }
    }
}

.section-password {
    color: var(--color-white);
    background-color: var(--color-twitter);
    .container-password {
        padding: 3rem 1rem;
        .generate-password__section-title__text {
            font-size: 1.1rem;
            font-weight: bold;
        }
        .generate-password__form__area {
            text-align: left;
            .generate-password__form-secret__input {
                width: 100%;
                padding: 2%;
                color: var(--color-white);
                font-size: 1rem;
                border: 1px solid #bebebe;
                border-radius: 10px;
                &::placeholder {
                    color: var(--color-gray-light);
                }
            }
        }
        .generate-password__notion__wrapper {
            color: var(--color-orange);
            font-weight: bold;
        }
    }
}

.section-share {
    .container-share {
        .generate-share__section-title__text {
            font-size: 1.1rem;
            font-weight: bold;
        }
        .generate-share__notion__wrapper {
            color: var(--color-orange);
            font-weight: bold;
        }
    }
}


.main__share-button__area {
    display: flex;
    flex-wrap: wrap;
    gap: 1%;
    font-size: 1rem;
    .main__share-button__wrapper {
        padding: 1rem 2rem;
        display: flex;
        justify-content: space-around;
        align-items: center;
        text-decoration: none;
        border-radius: 10px;
        &.--twitter {
            width: 10rem;
            color: #ffffff;
            background-color: var(--color-twitter);
            @media screen and (max-width: 480px) {
                width: 100%;
                justify-content: center;
                gap: 1rem;
            }
        }
    }
}

.section-share {
    .generate-share__urls__wrapper {
        margin: 3rem 0 0;
        .generate-share__description__text {
            font-size: .8rem;
        }
        .generate-share__header__text {
            margin: 1rem 0 0;
            font-size: .8rem;
            font-weight: bold;
        }
    }
}
</style>
